/**
 * ueditorForManuscriptBtnServiceModule 广电广电文稿编辑器按钮工厂
 * author Qian.qianchen 2019-04-04
 */
'use strict';
angular.module('ueditorForManuscriptBtnServiceModule', [])
    . factory('ueditorForManuscriptBtnService', ['$q', 'localStorageService', 'ueditorService', 'trsUploadAVNewService', 'modalDialog', function($q, localStorageService, ueditorService, trsUploadAVNewService, modalDialog) {
        return {

            /**
         * [insertMain description] 插入正文
         * @param  {[type]} UE    [description] 编辑器对象
         * @param  {[type]} scope [description] 编辑器指令作用域
         * @param  {[type]} ue    [description] 编辑器对象
         * @param  {[type]} i     [description] 按钮序号
         * @return {[type]}       [description]
         */
            insertMain: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('button1', function(editor, uiName) {
                // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var htmlTemplate = ['<p class="main_container" style="color:#206EFB">',
                                '<span class="main_title" contenteditable="false">【正文】</span>',
                                '</p>'
                            ].join('');
                            ue.execCommand('insertHtml', htmlTemplate);
                            ue.execCommand('forecolor', '#206EFB');
                            // console.log(ue.body.childNodes[0].setDisabled());
                            ue.fireEvent('contentchange');
                        }
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                    // 按钮的名字
                        name: 'insertMain',
                        // 提示
                        title: '插入正文',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/zheng.png) !important;background-repeat:no-repeat; background-size: 20px 20px',
                        // 点击时执行的命令
                        onclick: function() {
                        // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type !== undefined || scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/);
                return defer.promise;
            },

            /**
         * [insertLead description] 插入导语
         * @param  {[type]} UE    [description] 编辑器对象
         * @param  {[type]} scope [description] 编辑器指令作用域
         * @param  {[type]} ue    [description] 编辑器对象
         * @param  {[type]} i     [description] 按钮序号
         * @return {[type]}       [description]
         */
            insertLead: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('button', function(editor, uiName) {
                // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var htmlTemplate = ['<p class="lead_container" style="color:#58AB5C">',
                                '<span class="lead_title" contenteditable="false">【导语】</span>',
                                '</p>'
                            ].join('');
                            ue.execCommand('insertHtml', htmlTemplate);
                            ue.execCommand('forecolor', '#58AB5C');
                            // console.log(ue.body.childNodes[0].setDisabled());
                            ue.fireEvent('contentchange');
                        }
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                    // 按钮的名字
                        name: 'insertLead',
                        // 提示
                        title: '插入导语',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/dao.png) !important;background-repeat:no-repeat; background-size: 20px 20px',
                        // 点击时执行的命令
                        onclick: function() {
                        // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type !== undefined || scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/);
                return defer.promise;
            },

            /**
         * [insertAfterCompile description] 插入编后
         * @param  {[type]} UE    [description] 编辑器对象
         * @param  {[type]} scope [description] 编辑器指令作用域
         * @param  {[type]} ue    [description] 编辑器对象
         * @param  {[type]} i     [description] 按钮序号
         * @return {[type]}       [description]
         */
            insertAfterCompile: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('button2', function(editor, uiName) {
                // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var htmlTemplate = ['<p class="afterCompile_container" style="color:#E84F89">',
                                '<span class="afterCompile_title" contenteditable="false">【编后】</span>',
                                '</p>'
                            ].join('');
                            ue.execCommand('insertHtml', htmlTemplate);
                            ue.execCommand('forecolor', '#E84F89');
                            // console.log(ue.body.childNodes[0].setDisabled());
                            ue.fireEvent('contentchange');
                        }
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                    // 按钮的名字
                        name: 'insertAfterCompile',
                        // 提示
                        title: '插入编后',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/bian.png) !important;background-repeat:no-repeat; background-size: 20px 20px',
                        // 点击时执行的命令
                        onclick: function() {
                        // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type !== undefined || scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/);
                return defer.promise;
            },

            /**
         * [insertAfterCompile description] 排版
         * @param  {[type]} UE    [description] 编辑器对象
         * @param  {[type]} scope [description] 编辑器指令作用域
         * @param  {[type]} ue    [description] 编辑器对象
         * @param  {[type]} i     [description] 按钮序号
         * @return {[type]}       [description]
         */
            typeSetting: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('button3', function(editor, uiName) {
                // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var content = ue.getContent();
                            // console.log(ueditorService.sortManuscript(content));
                            ue.setContent(ueditorService.typesettingManuscript(content));
                        }
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                    // 按钮的名字
                        name: 'typeSetting',
                        // 提示
                        title: '排版',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/pai.png) !important;background-repeat:no-repeat; background-size: 20px 20px',
                        // 点击时执行的命令
                        onclick: function() {
                        // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type !== undefined || scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/);
                return defer.promise;
            },

            /**
         * [insertGuide description] 插入现场口导
         * @param  {[type]} UE    [description] 编辑器对象
         * @param  {[type]} scope [description] 编辑器指令作用域
         * @param  {[type]} ue    [description] 编辑器对象
         * @param  {[type]} i     [description] 按钮序号
         * @return {[type]}       [description]
         */
            insertGuide: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('button4', function(editor, uiName) {
                // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var htmlTemplate = ['<p style="color:#000">',
                                '<span>【现场口导】</span>',
                                '</p>'
                            ].join('');
                            ue.execCommand('insertHtml', htmlTemplate);
                            ue.execCommand('forecolor', '#000');
                            // console.log(ue.body.childNodes[0].setDisabled());
                            ue.fireEvent('contentchange');
                        }
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                    // 按钮的名字
                        name: 'insertGuide',
                        // 提示
                        title: '插入现场口导',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/kou.png) !important;background-repeat:no-repeat; background-size: 20px 20px',
                        // 点击时执行的命令
                        onclick: function() {
                        // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type !== undefined || scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/);
                return defer.promise;
            },

            /**
         * [insertActualSound description] 插入同期声
         * @param  {[type]} UE    [description] 编辑器对象
         * @param  {[type]} scope [description] 编辑器指令作用域
         * @param  {[type]} ue    [description] 编辑器对象
         * @param  {[type]} i     [description] 按钮序号
         * @return {[type]}       [description]
         */
            insertActualSound: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('button5', function(editor, uiName) {
                // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var htmlTemplate = ['<p style="color:#000">',
                                '<span>【同期声】</span>',
                                '</p>'
                            ].join('');
                            ue.execCommand('insertHtml', htmlTemplate);
                            ue.execCommand('forecolor', '#000');
                            // console.log(ue.body.childNodes[0].setDisabled());
                            ue.fireEvent('contentchange');
                        }
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                    // 按钮的名字
                        name: 'insertActualSound',
                        // 提示
                        title: '插入同期声',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/tong.png) !important;background-repeat:no-repeat; background-size: 20px 20px',
                        // 点击时执行的命令
                        onclick: function() {
                        // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type !== undefined || scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/);
                return defer.promise;
            },

            /**
         * [insertLiveSound description] 插入现场音
         * @param  {[type]} UE    [description] 编辑器对象
         * @param  {[type]} scope [description] 编辑器指令作用域
         * @param  {[type]} ue    [description] 编辑器对象
         * @param  {[type]} i     [description] 按钮序号
         * @return {[type]}       [description]
         */
            insertLiveSound: function(UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ''
                };
                UE.registerUI('button6', function(editor, uiName) {
                // 注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function() {
                            ue = ue ? ue : UE.getEditor('ueditor');
                            var htmlTemplate = ['<p style="color:#000">',
                                '<span>【现场音】</span>',
                                '</p>'
                            ].join('');
                            ue.execCommand('insertHtml', htmlTemplate);
                            ue.execCommand('forecolor', '#000');
                            // console.log(ue.body.childNodes[0].setDisabled());
                            ue.fireEvent('contentchange');
                        }
                    });

                    // 创建一个button
                    btn.obj = new UE.ui.Button({
                    // 按钮的名字
                        name: 'insertLiveSound',
                        // 提示
                        title: '插入现场音',
                        // 需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-image: url(lib/ueditor2/themes/default/images/yin.png) !important;background-repeat:no-repeat; background-size: 20px 20px',
                        // 点击时执行的命令
                        onclick: function() {
                        // 这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type !== undefined || scope.draftType !== 'video') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                } /* index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/);
                return defer.promise;
            },
        };
    }]);
